// extracted by mini-css-extract-plugin
module.exports = {"nav":"settingsIndex_nav__2_c4S"};